import { useSelector } from 'react-redux';
import { selectIsMotor } from 'app/store/data/quotationConfig';

export function useVehicleType() {
  const isMotor = useSelector(selectIsMotor);

  return {
    isMotor,
  };
}
